import { FilterConfig } from "@/interfaces/filter.interface";
import { UserRole } from "./user.constants";
import { FilterOperator } from "./filter.constant";

/**
 * User-specific filter configuration
 */
export const USER_FILTER_CONFIG: FilterConfig = {
  fields: [
    {
      id: "role",
      label: "Role",
      type: "multiselect",
      options: [UserRole.USER, UserRole.ADMIN],
      operators: [FilterOperator.IN, FilterOperator.NOT_IN],
      placeholder: "select a role",
      backendKey: "role",
    },
    {
      id: "accessTier",
      label: "Access Tier",
      type: "multiselect",
      options: ["group-1", "group-2"],
      operators: [FilterOperator.IN, FilterOperator.NOT_IN],
      placeholder: "select Access Tiers",
      backendKey: "accessTier",
    },
    {
      id: "email",
      label: "Email",
      type: "text",
      operators: [FilterOperator.EQUALS, FilterOperator.NOT_EQUALS, FilterOperator.CONTAINS],
      backendKey: "email",
      placeholder: "Type your email",

    },
  ],
  maxFilters: 3,
  allowDuplicateFields: false,
};


export const FILTER_OPERATOR_BACKEND_MAP: Record<FilterOperator, string> = {
  [FilterOperator.EQUALS]: "eq",
  [FilterOperator.NOT_EQUALS]: "neq",
  [FilterOperator.CONTAINS]: "contains",
  [FilterOperator.NOT_CONTAINS]: "not_contains",
  [FilterOperator.GREATER_THAN_OR_EQUAL]: "gte",
  [FilterOperator.LESS_THAN_OR_EQUAL]: "lte",
  [FilterOperator.IN]: "in",
  [FilterOperator.NOT_IN]: "not_in",
  [FilterOperator.NONE]: "none",
};


export const USER_TABLE_COLUMNS = {
  NAME: { id: "name", header: "Name / User ID" },
  EMAIL: { id: "email", header: "Email" },
  ROLE: { id: "role", header: "Role" },
  ACCESS_TIER: { id: "accessTier", header: "Access tier" },
  LAST_LOGIN: { id: "lastLogin", header: "Last Login" },
} as const;

export const UNLIMITED_TOKEN = -1;